/**
 * IAB podcast measurement: no media bytes before a viewer-initiated play.
 * hls.js runs with autoStartLoad: false, so before the first play only the
 * master manifest is fetched (that fills the quality menu); variant
 * playlists and segments wait for this gate.
 *
 * The gate opens on the first `play` event of the <video>, which every play
 * path fires: the poster, media-chrome's button / click / keyboard, the end
 * screen replay. It loads from the element's currentTime, so a chapter or
 * transcript seek made before the first play (which loads nothing by itself)
 * is where playback starts.
 *
 * startLoad/stopLoad are the audio/video switch's controls: an explicit
 * startLoad opens the gate too, so the play() that follows it never starts
 * a second load.
 */
export function createLoadGate(videoEl, hls) {
    let started = false

    function startLoad(seconds) {
        started = true
        hls.startLoad(seconds)
    }

    function onPlay() {
        if (started) {
            return
        }

        const position = videoEl.currentTime || 0

        startLoad(position > 0 ? position : -1)
    }

    videoEl.addEventListener("play", onPlay)

    return {
        startLoad,
        stopLoad() {
            if (started) {
                hls.stopLoad()
            }
        },
        get started() {
            return started
        },
        dispose() {
            videoEl.removeEventListener("play", onPlay)
        },
    }
}
